import { IconName } from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import createWrapper from '../createWrapper';

export interface OpStepperItem {
  label: string;
  icon: IconName;
}

interface OpStepper extends HTMLElement {
  items: OpStepperItem[];
}

const OpStepper = createWrapper<OpStepper>('op-stepper');

export default OpStepper;
